import type { ViewContainerRef } from '@angular/core';
import { Injectable } from '@angular/core';

import type { IntegrationKinds } from '@recruitee/integrations-types';
import { DialogService, DialogWidth } from '@recruitee/user-interface';

type ConnectConfig = {
  integrationKind: IntegrationKinds;
  redirectUrl?: string;
  vcRef: ViewContainerRef;
};

@Injectable({ providedIn: 'root' })
export class OAuthService {
  constructor(private dialogService: DialogService) {}

  public async connect(config: ConnectConfig) {
    const { OAuthCredentializeDialogComponent } = await import(
      './oauth-credentialize-dialog/oauth-credentialize-dialog.component'
    );
    const redirectUrl = config.redirectUrl || window.location.href;

    this.dialogService.openCustom(
      OAuthCredentializeDialogComponent,
      { width: DialogWidth.SmallXX },
      { redirectUrl, integrationKind: config.integrationKind },
      config.vcRef,
    );
  }
}
